// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button--left[data-v-fb93f4a6],.button--right[data-v-fb93f4a6]{height:54px!important;min-width:174px!important;box-shadow:0 3px 6px rgba(0,0,0,.1607843137254902);opacity:1;text-align:left;font:normal normal 700 24px/32px Segoe UI;letter-spacing:0}.col--right[data-v-fb93f4a6]{text-align:right}", ""]);
// Exports
module.exports = exports;
